<template>
  <div>
    <div class="right-title">
      <span>发送站内信</span>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <el-form :model="ruleForm" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-form-item label="接收角色:" >
          <el-checkbox-group v-model="ruleForm.jueseForm" style="line-height: 45px;">
            <el-checkbox label="候选人"></el-checkbox>
            <el-checkbox label="机构"></el-checkbox>
            <el-checkbox label="客服"></el-checkbox>
            <el-checkbox label="顾问"></el-checkbox>
            <el-checkbox label="总顾问" v-if="user.admin_type === 1"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="标题:" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="内容:" prop="content">
          <div style="height: 450px;">
            <quill class="quill" @getData="getData"></quill>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">立即发送</el-button>
        </el-form-item>
      </el-form>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'
  import quill from '../../../../components/quill'
  export default {
    name: "znxAdd",
    data(){
      return {
        ruleForm:{
          jueseForm:[],
          name:'',
          content:''
        },
      }
    },
    computed: {
      user(){
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 0)
    },
    methods:{
      //  发送表单
      submitForm() {
        let _arr = []
        if(this.ruleForm.jueseForm.indexOf('候选人')!==-1) _arr.push(1)
        if(this.ruleForm.jueseForm.indexOf('机构')!==-1) _arr.push(2)
        if(this.ruleForm.jueseForm.indexOf('顾问')!==-1) _arr.push(3)
        if(this.ruleForm.jueseForm.indexOf('总顾问')!==-1) _arr.push(4)
        if(this.ruleForm.jueseForm.indexOf('客服')!==-1) _arr.push(5)

        if(_arr.length === 0){
          this.$message.error('请选择接收对象')
          return
        }
        if(!this.ruleForm.name){
          this.$message.error('请填写标题')
          return
        }
        if(!this.ruleForm.content){
          this.$message.error('请填写内容')
          return
        }
        this.$api.apiContent.addZnx({
          adminId:this.user.id,
          recUserId:_arr.join(','),
          type:1,
          title:this.ruleForm.name,
          content:this.ruleForm.content,
          homeAlert:0
        }).then(res=>{
          this.$message.success(res.info)
          this.$router.go(-1)
        }).catch(e=>{
          this.$message.error(e.info)
        })
      },
      // 获取内容
      getData(data) {
        this.ruleForm.content = data
      },
      goBack() {     //  返回上一页
        this.$tools.goBack()
      },
    },
    watch:{

    },
    components:{
      footerBox,
      quill
    }
  }
</script>

<style scoped lang="scss">

</style>